import moment from "moment";
import { defineComponent } from "vue";
import { KeskkonnaMuutujad } from "./keskkonnamuutujad";

export default defineComponent({
    methods: {
        formateeriKuupaev: function (date: string | undefined) {
            return moment(date).format(KeskkonnaMuutujad.kuupaevFormaat);
        },
        formateeriKuupaevaAjaga: function (date: string | undefined) {
            return moment(date).format(KeskkonnaMuutujad.kuupaevAjagaFormaat);
        },
        formateeriAeg: function (date: string | undefined) {
            return moment(date).format(KeskkonnaMuutujad.kuupaevAjaFormaat);
        },
        formateeriNadalaPaev: function (date: string | undefined) {
            return moment(date).locale('et').format('dddd');
        },
    }
});